import { render, staticRenderFns } from "./PerformanceDisplay.vue?vue&type=template&id=28a25244&scoped=true&"
import script from "./PerformanceDisplay.vue?vue&type=script&lang=ts&"
export * from "./PerformanceDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceDisplay.vue?vue&type=style&index=0&id=28a25244&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a25244",
  null
  
)

export default component.exports